import { Grid } from '@material-ui/core';
import styled from 'styled-components';

export const ImageStyledGrid = styled(Grid)`
  min-height: 500px;
`;
